import { useArticles } from '../../../hooks/useArticles';
import { CardGTMData } from '../../../components/ArticleCard/CardUtils';
import { articleCardLocation } from '../../../utilities/gtm';
import { Box, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArticleMeta from '../../../types/ArticleMeta';
import { CONTENT_TYPE } from '../types/types';
import NewsCardSkeleton from '../../../components/News/NewsCardSkeleton';
import NewsArticleCard from '../../../components/News/NewsArticleCard';
import { getNewsRoute } from '../News/utils/newsUtils';
import { DividerWithContent } from '../../../common/components/DividerWithContent';

interface RelatedNewsSectionProps {
  primaryCategory: string;
}

const NEWS_LIMIT = 3;

function renderContent(articles: ArticleMeta[], isFetching: boolean) {
  if (isFetching) {
    return Array.from({ length: NEWS_LIMIT }).map((_, index) => (
      <NewsCardSkeleton key={index} />
    ));
  }

  return articles.map((article, index) => (
    <NewsArticleCard
      key={article.id}
      meta={article}
      heading='h3'
      gtmData={
        {
          index,
          location: articleCardLocation.ARTICLE_FOOTER_RELATED,
        } as CardGTMData
      }
    />
  ));
}

export default function RelatedNewsSection({
  primaryCategory,
}: RelatedNewsSectionProps) {
  const { articles, isFetching, hasError } = useArticles({
    category: primaryCategory,
    contentType: [CONTENT_TYPE.LegalNews], // Only fetch news content
    limit: NEWS_LIMIT,
  });

  if (hasError) {
    return <Box>Uutisia ei saatu ladattua.</Box>;
  }

  if (!isFetching && (!articles || articles.length === 0)) {
    return <Box>Ei uutisia</Box>;
  }

  return (
    <Box>
      <Stack direction='column' spacing={1}>
        {renderContent(articles, isFetching)}
      </Stack>
      <DividerWithContent>
        <Button
          component={RouterLink}
          to={getNewsRoute(primaryCategory)}
          endIcon={<ArrowForwardIcon />}
          variant='outlined'
        >
          Lisää uutisia aiheesta
        </Button>
      </DividerWithContent>
    </Box>
  );
}
